module.exports = __webpack_public_path__ + "img/PSLRLOCClock.8b202fd4.svg";